import { render, staticRenderFns } from "./WelcomeCardPreview.vue?vue&type=template&id=5427086e&scoped=true&"
import script from "./WelcomeCardPreview.vue?vue&type=script&lang=js&"
export * from "./WelcomeCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCardPreview.vue?vue&type=style&index=0&id=5427086e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427086e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VIcon,VImg,VRow})
